export const NAME = 'dashboard-campaigns';
